import React, { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PasswordInput from '../../components/PasswordInput/PasswordInput';
import { Link , useNavigate } from 'react-router-dom'
import axiosInstance from '../../Utils/axiosInstance';

const Signup = () => {
  const [Name, setName] = useState("")
  const [password, setPassword] = useState("");
  const [confirmpassword, setconfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);

  const navigate=useNavigate()
  const handleSignup = async (e) => {
    e.preventDefault();
    if (!Name) {
      setError("Please enter your name");
      return;
    }

    if (!email) {
      setError("Please Enter Email!")
      return;

    }
    if (!password) {
      setError("Please Enter Password!")
      return;
    }
    if (password !== confirmpassword) {
      setError("Password does not match!")
      return;
    }



    setError(" ")

    try {
      const response = await axiosInstance.post('/create-account', {
        fullname: Name,
        email: email,
        password: password
      });

      //Successful Login 
      if (response.data) {
        navigate('/login')
      }


    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message)
      } else {
        setError("Something went wrong! Please try again later.")
      }
    }


  }



  return (
    <div>
      <Navbar />
      <section class="pt-5 bg-gray-200">
        <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <div class="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
            <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 class="text-xl font-bold leading-tight tracking-tight text-black md:text-2xl">
                Create an account
              </h1>
              <form onSubmit={handleSignup} class="space-y-4 md:space-y-6" action="#">
                <div>
                  <label for="name" class="block mb-2 text-sm font-medium text-black">Full Name</label>
                  <input type="text" name="name" id="name" class="bg-gray-50 border border-gray-300 text-black text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    placeholder=" "
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    required="" />
                </div>
                <div>
                  <label for="email" class="block mb-2 text-sm font-medium text-black">Your email</label>
                  <input type="email" name="email" id="email" class="bg-gray-50 border border-gray-300 text-black text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    placeholder=" "
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required="" />
                </div>
                <div>
                  <label for="password" class="block mb-2 text-sm font-medium text-black">Password</label>
                  <PasswordInput
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div>
                  <label for="confirm-password" class="block mb-2 text-sm font-medium text-black">Confirm password</label>
                  <PasswordInput
                    value={confirmpassword}
                    onChange={(e) => setconfirmPassword(e.target.value)}
                  />
                </div>

                {error && <p className='text-red-600 text-sm ' >{error}</p>}

                <button type="submit" class="w-full text-white bg-blue-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-base px-5 py-2.5 text-center">Create account</button>
                <p class="text-sm font-light text-black">
                  Already have an account? <Link to='/login' class=" font-bold text-blue-600 hover:underline">Login here</Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Signup
